export default __webpack_public_path__ + "static/media/asset-5.f1566568.svg";